export class DashboardQueryModel {
  StartDate: string;
  EndDate: string;
  OrgId?: number;
  ModalityId?: number;
  OrderId?: number;
  OrgIds?: number[];
  ModalityNameList?: string[];
  TimeZone : string;
  
  OrderIds:number[];
  RadIds:number[];
}
